import { useEffect, useState } from "react";

// this hook can be used to get the value of a key from local storage
// as nextjs pre-renders the client page on the server, the local storage is not available on the server
export const useLocalStorageValue = (
  key: string,
  asJson = false,
  defaultValue: any = "",
) => {
  const [value, setValue] = useState<any>(defaultValue);

  useEffect(() => {
    const localStorageValue = localStorage.getItem(key);
    if (!localStorageValue) return;
    if (asJson) {
      setValue(localStorageValue ? JSON.parse(localStorageValue) : []);
    } else {
      setValue(localStorageValue);
    }
  }, []);

  const setLocalStorageValue = (value: any) => {
    setValue(value);
    localStorage.setItem(key, JSON.stringify(value));
  };

  const getLocalStorageValue = () => {
    return localStorage.getItem(key);
  };

  return { value, setLocalStorageValue, getLocalStorageValue };
};
